import React, {
  useContext,
  useState,
  KeyboardEvent
} from 'react'
import { RadioButton } from '@zuto/atoms'
import { GridItem } from '@zuto/core/src/grid'
import { useCallbackOnce } from '@zuto/utilities'
import QuestionComponentProps from '../../../Questions/question-component-props'
import QuestionKey from '../../../Questions/question-key'
import AppFormQuestion from '../../AppFormQuestion'
import { ApplicationFormContext } from '../../ApplicationForm/ApplicationFormContext'
import withQuestion from '../../HOC/withQuestion'
import withFade from '../../HOC/withFade'
import {
  trackMultipleInputChoice,
  handlePrevButtonClick,
  determineRadioVariant,
  questionFontStyle
} from '../utils'
import NavigationButtons from '../../NavigationButtons/NavigationButtons'
import TitleOptions from './TitleOptions'

const TitleQuestion = ({
  existingAnswers,
  disablePrevious
}: QuestionComponentProps): JSX.Element => {
  const appFormContext = useContext(ApplicationFormContext)
  const [answer, setAnswer] = useState(existingAnswers)
  const [nextButtonCb] = useCallbackOnce()
  const [previousButtonCb] = useCallbackOnce()
  const {
    prominentColourScheme
  } = appFormContext.featureSwitches ?? {}

  const nextQuestion = () => {
    trackMultipleInputChoice({ label: `title+${answer}` })
    appFormContext.dispatch({
      type: 'QUESTION_ANSWERED',
      name: QuestionKey.TITLE,
      value: answer
    })
  }

  const previousQuestion = () => {
    handlePrevButtonClick(
      appFormContext.dispatch,
      { name: QuestionKey.TITLE, value: answer }
    )
  }

  const handleEnterKeyPress = (e: KeyboardEvent) => {
    if (e.code === 'Enter' && answer) {
      nextButtonCb(nextQuestion)
    }
  }

  return (
    <>
      <GridItem gridColumn={['auto / span 12', '3 / span 8']} minHeight="174px">
        <AppFormQuestion
          questionKey={QuestionKey.TITLE}
          mt={3}
          mb={0}
          textStyle={questionFontStyle}
        >
          What&apos;s your title?
        </AppFormQuestion>
        <RadioButton
          options={TitleOptions}
          id="title"
          direction="vertical"
          alignment="center"
          mb={[4, 3]}
          valueChanged={(value) => setAnswer(value.toString())}
          onKeyPress={handleEnterKeyPress}
          defaultState={answer}
          variant={determineRadioVariant({
            prominentColourScheme, 
            smallRadiosSideBySide: false, 
            sideBySideEnabled: true
          })}
        />
      </GridItem>
      <NavigationButtons
        nextHandler={() => nextButtonCb(nextQuestion)}
        previousHandler={() => previousButtonCb(previousQuestion)}
        disableNext={!answer}
        disablePrevious={disablePrevious ? 'invisible' : undefined}
      />
    </>
  )
}

export default withFade(withQuestion(TitleQuestion))
